import React from 'react';

import Anchor from '../../../../../components/link/Anchor';
import Button from '../../../../../components/Button';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import { convertTextToShort, setColumnWidth, openNewWindow, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { NOTICE_PRODUCT_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { NOTICE_PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/noticeProductConstants';

/**
 *  브랜드의 상품 공지사항 리스트
 */
const columns = (data) => {
  const { list } = data;

  return [
    {
      Header: '상세보기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="상세보기"
          onClick={() => openNewWindow(setDetailPageUrl(NOTICE_PRODUCT_DETAIL_URL_PATH, row.original.id))}
        />
      ),
    },
    {
      accessor: 'id',
      Header: '상세보기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(NOTICE_PRODUCT_DETAIL_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      fixed: 'left',
      width: 120,
      Cell: (row) => NOTICE_PRODUCT_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'title',
      Header: '제목',
      resizable: true,
      width: setColumnWidth(list, 'title'),
    },
    {
      accessor: 'content',
      Header: '내용',
      width: 300,
      Cell: (row) => (
        <OpenPreviewProductDetail
          disabledActiveValue={true}
          text={convertTextToShort(row.value, 30)}
          storeId={row.original.storeId}
          storeName={row.original.storeName}
          noticeContent={row.value}
          productNoticeId={row.original.id}
        />
      ),
    },
    {
      accessor: 'memo',
      Header: '메모',
      width: 300,
      Cell: (row) => convertTextToShort(row.value, 30),
    },
    {
      accessor: 'registeredProductCount',
      Header: '등록된 상품',
    },
    {
      accessor: 'period',
      Header: '노출 기간',
      width: 320,
      Cell: (row) =>
        row.original.startDate && row.original.endDate
          ? `${setDateFormat(row.original.startDate, DATE_FORMAT.YMD_DASH_FORMAT)}~${setDateFormat(
              row.original.endDate,
              DATE_FORMAT.YMD_DASH_FORMAT,
            )}`
          : '-',
    },
    {
      accessor: 'createDate',
      Header: '작성일',
      width: 100,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
